<!-- src/components/HeaderComponent.vue -->
<template>
  <header class="header">
    <div class="date artistic_font_numbers">{{ date }}</div>
    <div class="title">石化园区访客预约系统大屏</div>
    <div class="admin">
      <span>{{ user.username?.value }}</span>
      &nbsp;
      <a href="/index" style="color: inherit">管理后台</a>
      &nbsp;
      <LogoutOutlined
        class="u-clickable"
        @click="() => logout(false)"
        title="退出登录"
      ></LogoutOutlined>
    </div>
  </header>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, toRefs } from 'vue'
  import dayjs from 'dayjs'
  import 'dayjs/locale/zh-cn'
  import { useStore } from 'vuex'
  import { LogoutOutlined } from '@ant-design/icons-vue'
  import { logout } from '@/utils/auth'
  dayjs.locale('zh-cn')

  //1.时间
  const format = 'YYYY/MM/DD dddd HH:mm:ss'
  const date = ref(dayjs().format(format))
  const timer = ref()
  // 定义更新时间的函数
  const updateTime = () => {
    date.value = dayjs().format(format) // 实时更新的当前时间
  }
  onMounted(() => {
    timer.value = setInterval(updateTime, 1000)
  })
  onUnmounted(() => clearInterval(timer.value))

  //2.用户信息
  const store = useStore()
  const user = toRefs(store.state.user)
</script>

<style scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    flex-shrink: 0;
    position: relative;
  }

  .header .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 29px; /* 设置标题字体大小 */
    font-weight: bold; /* 设置标题粗体 */
  }

  .header .date,
  .header .admin {
    flex-shrink: 0;
  }
</style>
